import React from 'react';

const RefreshInfo: React.FC = () => (
  <div className="d-flex refresh-container justify-content-center align-items-center bg-light mb-3 border">
    <h2>Refresh the page to get bid list</h2>
  </div>
);

export default RefreshInfo;
